/* eslint-disable import/prefer-default-export */
import { TimelineVehicleStatesMessages, TranslationTimelineVehicleStatesMessages } from "../interfaces";

export const messages: TranslationTimelineVehicleStatesMessages = {
  [TimelineVehicleStatesMessages.statesTitle]: "States",
  [TimelineVehicleStatesMessages.manometer]: "Manometer",
  [TimelineVehicleStatesMessages.blockedVehicle]: "Locked vehicle",
  [TimelineVehicleStatesMessages.blockingDate]: "Lock date",
  [TimelineVehicleStatesMessages.postUnloadIdleTime]: "Post-unload idleness",
  [TimelineVehicleStatesMessages.effectiveUnloadTime]: "Effective unloading",
  [TimelineVehicleStatesMessages.unloadBreakdownTitle]: "Within Unloading",
  [TimelineVehicleStatesMessages.unloadBreakdownHelp]: "Effective unloading: drum unloading.\n"
    + "Post-unload idleness: drum stopped until the truck leaves the jobsite."
};
